export default __webpack_public_path__ + "static/media/BasicVerfication.e792db83.svg";